import {Modal} from "../../__snowpack__/pkg/antd.js";
export const windowSafeOpen = (url, formatMessage) => {
  const tempWindow = window.open();
  if (tempWindow == null) {
    Modal.warning({
      title: formatMessage({id: "Notification"}),
      content: formatMessage({id: "BrowserBlockedInfo"}),
      okText: formatMessage({id: "GoContinue"}),
      onOk: () => {
        window.open(url);
      }
    });
  } else {
    tempWindow.document.body.innerHTML = formatMessage({id: "tryingToLoad"});
    tempWindow.location.href = url;
  }
};
